const IdCardIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M528 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm0 256H144c0-53 43-96 96-96h96c53 0 96 43 96 96H288zm240-32c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16v64z" />
  </svg>
);

export default IdCardIcon;
